import { render, staticRenderFns } from "./asideMenu.vue?vue&type=template&id=f7927710&scoped=true"
import script from "./asideMenu.vue?vue&type=script&lang=js"
export * from "./asideMenu.vue?vue&type=script&lang=js"
import style0 from "./asideMenu.vue?vue&type=style&index=0&id=f7927710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7927710",
  null
  
)

export default component.exports